import { render, staticRenderFns } from "./PoolEcouponDetail.vue?vue&type=template&id=6e2cca0c&"
import script from "./PoolEcouponDetail.vue?vue&type=script&lang=js&"
export * from "./PoolEcouponDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports